import React from "react";
import { ColorSystemProps, GOI_WEB_URL } from "../../../constants";
import { Box, Stack } from "@mui/material";
import { FullWidthRadiusButton } from "../../common/Buttons/FullWidthRadiusButton";
import { ColorIcon } from "../../common/Icons";
import { ClickEventType, ParlorDetailProps } from "../../../types";
import { NextLink } from "../../common";

interface CTypeCTAProps {
  mainColor: ColorSystemProps;
  // sidoName?: string;
  // sigunguName?: string;
  defaultParlor?: ParlorDetailProps;
  event: ClickEventType;
}

export function CTypeCTA({
  mainColor,
  // sidoName,
  // sigunguName,
  defaultParlor,
  event,
}: CTypeCTAProps) {
  const companyname = defaultParlor?.companyname || "장례식장";
  const detailHref = defaultParlor?.id
    ? `/match/parlor-requests/${defaultParlor.id}/?utm_source=dogsound`
    : "/match/request/?utm_source=dogsound";

  return (
    <Stack gap="16px" padding="0 20px 20px">
      <Stack gap="10px">
        <p style={{ textAlign: "center" }} className="subtitle_14_sb">
          {/* 장례식장 비용이 다가 아닙니다. */}
          고이에서는 e하늘 장사정보시스템 기반으로
          <br />
          {companyname}의
          <br />
          상세 견적을 안내해드립니다.
        </p>
        <FullWidthRadiusButton
          backgroundColor={mainColor.c400}
          text="장례식장 비용 알아보기"
          href={GOI_WEB_URL + detailHref}
          event={event}
        />
      </Stack>

      <Stack flexDirection="row" gap="6px" alignItems="center">
        <ColorIcon name="icon-check-fill-mono" size={14} color="" />
        <Box className="caption_12_m">이 지역 포함해서 찾기</Box>
      </Stack>

      <NextLink
        href={`${GOI_WEB_URL}/guidebook/tip/before/4?utm_source=dogsound`}
        className="subtitle_14_b"
        style={{
          color: mainColor.c500,
          textAlign: "center",
          textDecoration: "underline",
          margin: "0 auto",
          padding: "10px",
        }}
        event={{
          ...event,
          trigger_and_target: "content-uv_before_4",
        }}
      >
        장례식장 vs 상조회사 나에게 맞는 곳은?
      </NextLink>
    </Stack>
  );
}
